import { createToken } from 'chevrotain';


const WHITESPACE_SINGLE = createToken({
  name: 'WHITESPACE_SINGLE',
  pattern: /\s/,
});

const STRING_LITERAL = createToken({
  name: 'STRING_LITERAL',
  pattern: /[^()<>]+/,
});

const STRING_LITERAL_OPENING_TAG = createToken({
  name: 'STRING_LITERAL_OPENING_TAG',
  pattern: /<[^()]*?>/,
});

const STRING_LITERAL_CLOSING_TAG = createToken({
  name: 'STRING_LITERAL_CLOSING_TAG',
  pattern: /<\/[^()]*?>/,
});

const NOTE_BIVIRGA =
  createToken({ name: 'NOTE_BIVIRGA', pattern: /[a-m]vv/i });
const NOTE_TRIVIRGA =
  createToken({ name: 'NOTE_TRIVIRGA', pattern: /[a-m]vvv/i });

const NOTE_DISTROPHA =
  createToken({ name: 'NOTE_DISTROPHA', pattern: /[a-mA-M]ss/ });
const NOTE_DISTROPHA_AUCTUS_ASCENDENS =
  createToken({ name: 'NOTE_DISTROPHA_AUCTUS_ASCENDENS', pattern: /[a-mA-M]ss[<>]/ });

const NOTE_TRISTROPHA =
  createToken({ name: 'NOTE_TRISTROPHA', pattern: /[a-mA-M]sss/ });
const NOTE_TRISTROPHA_AUCTUS_ASCENDENS =
  createToken({ name: 'NOTE_TRISTROPHA_AUCTUS_ASCENDENS', pattern: /[a-mA-M]sss[<>]/ });

const NOTE_PUNCTUM =
  createToken({ name: 'NOTE_PUNCTUM', pattern: /[a-m]/ });
const NOTE_PUNCTUM_INITIO_DEBILIS =
  createToken({ name: 'NOTE_PUNCTUM_INITIO_DEBILIS', pattern: /-[a-m]/ });
const NOTE_PUNCTUM_FUSED =
  createToken({ name: 'NOTE_PUNCTUM_FUSED', pattern: /@[a-m]/ });

const NOTE_PUNCTUM_INCLINATUM =
  createToken({ name: 'NOTE_PUNCTUM_INCLINATUM', pattern: /[A-M][012]?/ });
const NOTE_PUNCTUM_INCLINATUM_INITIO_DEBILIS =
  createToken({ name: 'NOTE_PUNCTUM_INCLINATUM_INITIO_DEBILIS', pattern: /-[A-M][012]?/ });

const NOTE_PUNCTUM_INCLINATUM_FUSED =
  createToken({ name: 'NOTE_PUNCTUM_INCLINATUM_FUSED', pattern: /@[A-M][012]?/ });

const CLEF =
  createToken({ name: 'CLEF', pattern: /[cf][1-5]/ });
const CLEF_FLATTED =
  createToken({ name: 'CLEF_FLATTED', pattern: /[cf]b[1-5]/ });

const CLEF_SECONDARY =
  createToken({ name: 'CLEF_SECONDARY', pattern: /@[cf][1-5]/ });
const CLEF_SECONDARY_FLATTED =
  createToken({ name: 'CLEF_SECONDARY_FLATTED', pattern: /@[cf]b[1-5]/ });


// ALTERNATIONS
const S_FLAT =
  createToken({ name: 'S_FLAT', pattern: /x/ });

const S_FLAT_PAREN =
  createToken({ name: 'S_FLAT_PAREN', pattern: /x\?/ });

const S_SHARP =
  createToken({ name: 'S_SHARP', pattern: /#/ });

const S_SHARP_PAREN =
  createToken({ name: 'S_SHARP_PAREN', pattern: /#\?/ });

const S_NATURAL =
  createToken({ name: 'S_NATURAL', pattern: /y/ });

const S_NATURAL_PAREN =
  createToken({ name: 'S_NATURAL_PAREN', pattern: /y\?/ });

const S_LINEA =
  createToken({ name: 'S_LINEA', pattern: /=/ });

const S_LINEA_PUNCTUM =
  createToken({ name: 'S_LINEA_PUNCTUM', pattern: /R/ });

// CAVUM
const CAVUM =
  createToken({ name: 'CAVUM', pattern: /r/ });

const S_LINEA_PUNCTUM_CAVUM =
  createToken({ name: 'S_LINEA_PUNCTUM_CAVUM', pattern: /r0/ });


// SIGNS
const V_EPISEMA =
  createToken({ name: 'V_EPISEMA', pattern: /'[01]?/ });
const H_EPISEMA =
  createToken({ name: 'H_EPISEMA', pattern: /_[0-5]*/ });
const PUNCTUM_MORA =
  createToken({ name: 'PUNCTUM_MORA', pattern: /\.[01]?/ });

const TAIL_LIQUIESCENIA_DEMINUTUS =
  createToken({ name: 'TAIL_LIQUIESCENIA_DEMINUTUS', pattern: /~/ });

const TAIL_LIQUIESCENIA_AUCTUS_DESCENDENS =
  createToken({ name: 'TAIL_LIQUIESCENIA_AUCTUS_DESCENDENS', pattern: />/ });

const TAIL_LIQUIESCENIA =
  createToken({ name: 'TAIL_LIQUIESCENIA', pattern: /</ });

const S_QUADRATUM =
  createToken({ name: 'S_QUADRATUM', pattern: /q/ });

const S_ORISCUS_UNDETERMINED =
  createToken({ name: 'S_ORISCUS_UNDETERMINED', pattern: /o/ });

const S_ORISCUS_DESCENDENS =
  createToken({ name: 'S_ORISCUS_DESCENDENS', pattern: /o0/ });

const S_ORISCUS_ASCENDENS =
  createToken({ name: 'S_ORISCUS_ASCENDENS', pattern: /o1/ });

const S_ORISCUS_SCAPUS_UNDETERMINED =
  createToken({ name: 'S_ORISCUS_SCAPUS_UNDETERMINED', pattern: /O/ });

const S_ORISCUS_SCAPUS_DESCENDENS =
  createToken({ name: 'S_ORISCUS_SCAPUS_DESCENDENS', pattern: /O0/ });

const S_ORISCUS_SCAPUS_ASCENDENS =
  createToken({ name: 'S_ORISCUS_SCAPUS_ASCENDENS', pattern: /O1/ });

const S_QUILISMA =
  createToken({ name: 'S_QUILISMA', pattern: /w/ });

const S_QUILISMA_QUADRATUM =
  createToken({ name: 'S_QUILISMA_QUADRATUM', pattern: /W/ });

const S_VIRGA =
  createToken({ name: 'S_VIRGA', pattern: /v/ });

const S_VIRGA_REVERSA =
  createToken({ name: 'S_VIRGA_REVERSA', pattern: /V/ });

const S_STROPHA =
  createToken({ name: 'S_STROPHA', pattern: /s/ });

// SEPARATORS

const SP_HALF_SPACE =
  createToken({ name: 'SP_HALF_SPACE', pattern: /!0/ });

const SP_INTERGLYPH_SPACE =
  createToken({ name: 'SP_INTERGLYPH_SPACE', pattern: /!/ });

const SP_NEUMATIC_CUT =
  createToken({ name: 'SP_NEUMATIC_CUT', pattern: /\// });

const SP_GLYPH_SPACE =
  createToken({ name: 'SP_GLYPH_SPACE', pattern: /\\/ });

const SP_LARGER_SPACE =
  createToken({ name: 'SP_LARGER_SPACE', pattern: /\/\// });

const SP_LARGER_SPACE_NB =
  createToken({ name: 'SP_LARGER_SPACE_NB', pattern: /!\/\// });

const SP_GLYPH_SPACE_NB =
  createToken({ name: 'SP_GLYPH_SPACE_NB', pattern: /!\\/ });

const SP_ZERO_WIDTH =
  createToken({ name: 'SP_ZERO_WIDTH', pattern: /!\/[^\\/ ]/ });

// CUSTOS

const CUSTOS =
  createToken({ name: 'CUSTOS', pattern: /z0/ });

const MANUAL_CUSTOS =
  createToken({ name: 'MANUAL_CUSTOS', pattern: /[a-m]\+/ });

// SEPARATORS

const B_VIRGULA =
  createToken({ name: 'B_VIRGULA', pattern: /`/ });

const B_VIRGULA_HIGH =
  createToken({ name: 'B_VIRGULA_HIGH', pattern: /`0/ });

const B_VIRGULA_PAREN =
  createToken({ name: 'B_VIRGULA_PAREN', pattern: /`\?/ });

const B_VIRGULA_PAREN_HIGH =
  createToken({ name: 'B_VIRGULA_PAREN_HIGH', pattern: /`0\?|`\?0/ });

const B_DIVISIO_MINIMIS =
  createToken({ name: 'B_DIVISIO_MINIMIS', pattern: /\^/ });

const B_DIVISIO_MINIMIS_HIGH =
  createToken({ name: 'B_DIVISIO_MINIMIS_HIGH', pattern: /\^0/ });

const B_DIVISIO_MINIMA =
  createToken({ name: 'B_DIVISIO_MINIMA', pattern: /,/ });

const B_DIVISIO_MINIMA_HIGH =
  createToken({ name: 'B_DIVISIO_MINIMA_HIGH', pattern: /,0/ });

const B_DIVISIO_MINIMA_PAREN =
  createToken({ name: 'B_DIVISIO_MINIMA_PAREN', pattern: /,\?/ });

const B_DIVISIO_MINIMA_PAREN_HIGH =
  createToken({ name: 'B_DIVISIO_MINIMA_PAREN_HIGH', pattern: /,0\?|,\?0/ });

const B_DOMINICAN_BAR =
  createToken({ name: 'B_DOMINICAN_BAR', pattern: /[,;][1-8]/ });

const B_DIVISIO_MINOR =
  createToken({ name: 'B_DIVISIO_MINOR', pattern: /;/ });

const B_DIVISIO_MAIOR =
  createToken({ name: 'B_DIVISIO_MAIOR', pattern: /:/ });

const B_DIVISIO_FINALIS =
  createToken({ name: 'B_DIVISIO_FINALIS', pattern: /::/ });

const B_DIVISIO_MAIOR_DOTTED =
  createToken({ name: 'B_DIVISIO_MAIOR_DOTTED', pattern: /:\?/ });

// END OF LINE

const END_OF_LINE =
  createToken({ name: 'END_OF_LINE', pattern: /z/ });
const END_OF_LINE_FORSES_CUSTOS_ON =
  createToken({ name: 'END_OF_LINE_FORSES_CUSTOS_ON', pattern: /z\+/ });
const END_OF_LINE_FORSES_CUSTOS =
  createToken({ name: 'END_OF_LINE_FORSES_CUSTOS', pattern: /z-/ });
const END_OF_LINE_RAGGED =
  createToken({ name: 'END_OF_LINE_RAGGED', pattern: /Z/ });
const END_OF_LINE_RAGGED_CUSTOS_ON =
  createToken({ name: 'END_OF_LINE_RAGGED_CUSTOS_ON', pattern: /Z\+/ });
const END_OF_LINE_RAGGED_CUSTOS =
  createToken({ name: 'END_OF_LINE_RAGGED_CUSTOS', pattern: /Z-/ });

// NABC

const NABC_HORIZONTAL_SPACING_ADJUSTMENT = createToken({
  name: 'NABC_HORIZONTAL_SPACING_ADJUSTMENT',
  pattern: /[/`]+/
});

const NABC_BASIC_GLYPH_GALL = createToken({
  name: 'NABC_BASIC_GLYPH_GALL',
  pattern: /vi|pu|ta|gr|cl|pe|po|to|ci|sc|pf|sf|tr|st|ds|ts|tg|bv|tv|pr|pi|vs|or|sa|pq|ql|qi|pt/
});

const NABC_BASIC_GLYPH_LAON = createToken({
  name: 'NABC_BASIC_GLYPH_LAON',
  pattern: /un|vi|pu|ta|gr|cl|oc|pe|po|to|ci|sc|pf|sf|tr|ds|ts|tg|bv|tv|pr|pi|vs|or|sa|pq|ql|pt/
});

const NABC_GLYPH_MODIFIER = createToken({
  name: 'NABC_GLYPH_MODIFIER',
  pattern: /[SGM\->~1-9]+/
});

const NABC_SUBPUNCTIS_AND_PREPUNCTIS_GALL = createToken({
  name: 'NABC_SUBPUNCTIS_AND_PREPUNCTIS_GALL',
  pattern: /(su|pp)(t|u|v|w|x|y)?([1-9])/ // number represents number of repetitions
});

const NABC_SUBPUNCTIS_AND_PREPUNCTIS_LAON = createToken({
  name: 'NABC_SUBPUNCTIS_AND_PREPUNCTIS_LAON',
  pattern: /(su|pp)(n|q|z|x)?([1-9])/ // number represents number of repetitions
});

const NABC_SIGNIFICANT_LETTER_GALL = createToken({
  name: 'NABC_SIGNIFICANT_LETTER_GALL',
  // eslint-disable-next-line max-len
  pattern: /(ls)(al|am|b|c|cm|co|cw|d|e|eq|ew|fid|fr|g|i|im|iv|k|l|lb|lc|len|lm|lp|lt|m|moll|p|par|pfec|pm|pulcre|s|sb|sc|simil|simul|sm|st|sta|t|tb|tm|tw|v|vol|x)([1-46-9])/ // number represents position
});

const NABC_SIGNIFICANT_LETTER_LAON = createToken({
  name: 'NABC_SIGNIFICANT_LETTER_LAON',
  // eslint-disable-next-line max-len
  pattern: /(ls)(a|c|eq|eq-|equ|f|h|hn|hp|l|n|nl|nt|m|md|s|simp|simpl|sp|st|t|th)([1-9])/ // number represents position
});

const NABC_SIGNIFICANT_LETTER_TIRONIAN_LAON = createToken({
  name: 'NABC_SIGNIFICANT_LETTER_TIRONIAN_LAON',
  // eslint-disable-next-line max-len
  pattern: /(lt)(i|do|dr|dx|ps|qm|sb|se|sj|sl|sn|sp|sr|st|us)([1-9])/ // number represents position
});


// const NABC_ERROR = createToken({
//   name: 'NABC_ERROR'
// });

const NABC_PITCH = createToken({
  name: 'NABC_PITCH',
  // eslint-disable-next-line max-len
  pattern: /(h)([a-m])/
});

const NABC_COMPLEX_NEUME_SEPARATOR = createToken({
  name: 'NABC_COMPLEX_NEUME_SEPARATOR',
  pattern: /!/
});

export {
  CLEF,
  CLEF_FLATTED,
  CLEF_SECONDARY,
  CLEF_SECONDARY_FLATTED,
  H_EPISEMA,
  NOTE_BIVIRGA,
  NOTE_DISTROPHA,
  NOTE_DISTROPHA_AUCTUS_ASCENDENS,
  NOTE_PUNCTUM, NOTE_PUNCTUM_FUSED,
  NOTE_PUNCTUM_INCLINATUM,
  NOTE_PUNCTUM_INCLINATUM_FUSED,
  NOTE_PUNCTUM_INCLINATUM_INITIO_DEBILIS,
  NOTE_PUNCTUM_INITIO_DEBILIS, NOTE_TRISTROPHA,
  NOTE_TRISTROPHA_AUCTUS_ASCENDENS, NOTE_TRIVIRGA,
  PUNCTUM_MORA,
  STRING_LITERAL_OPENING_TAG,
  STRING_LITERAL_CLOSING_TAG,
  STRING_LITERAL,

  B_DOMINICAN_BAR,
  B_VIRGULA_PAREN_HIGH,
  B_VIRGULA_PAREN,
  B_VIRGULA_HIGH,
  B_VIRGULA,
  B_DIVISIO_MINIMIS_HIGH,
  B_DIVISIO_MINIMIS,
  B_DIVISIO_MINIMA_PAREN_HIGH,
  B_DIVISIO_MINIMA_PAREN,
  B_DIVISIO_MINIMA_HIGH,
  B_DIVISIO_MINIMA,
  B_DIVISIO_MINOR,
  B_DIVISIO_FINALIS,
  B_DIVISIO_MAIOR_DOTTED,
  B_DIVISIO_MAIOR,

  TAIL_LIQUIESCENIA,
  TAIL_LIQUIESCENIA_AUCTUS_DESCENDENS,
  TAIL_LIQUIESCENIA_DEMINUTUS,

  S_QUADRATUM,
  S_ORISCUS_UNDETERMINED,
  S_ORISCUS_DESCENDENS,
  S_ORISCUS_ASCENDENS,
  S_ORISCUS_SCAPUS_UNDETERMINED,
  S_ORISCUS_SCAPUS_DESCENDENS,
  S_ORISCUS_SCAPUS_ASCENDENS,
  S_QUILISMA,
  S_QUILISMA_QUADRATUM,
  S_VIRGA,
  S_VIRGA_REVERSA,
  S_STROPHA,

  S_FLAT,
  S_FLAT_PAREN,
  S_SHARP,
  S_SHARP_PAREN,
  S_NATURAL,
  S_NATURAL_PAREN,
  S_LINEA,
  S_LINEA_PUNCTUM,

  CAVUM,
  S_LINEA_PUNCTUM_CAVUM,

  SP_HALF_SPACE,
  SP_INTERGLYPH_SPACE,
  SP_NEUMATIC_CUT,
  SP_GLYPH_SPACE,
  SP_LARGER_SPACE,
  SP_LARGER_SPACE_NB,
  SP_GLYPH_SPACE_NB,
  SP_ZERO_WIDTH,

  END_OF_LINE,
  END_OF_LINE_FORSES_CUSTOS,
  END_OF_LINE_FORSES_CUSTOS_ON,

  END_OF_LINE_RAGGED,
  END_OF_LINE_RAGGED_CUSTOS,
  END_OF_LINE_RAGGED_CUSTOS_ON,

  CUSTOS,
  MANUAL_CUSTOS,

  V_EPISEMA,
  WHITESPACE_SINGLE,

  NABC_COMPLEX_NEUME_SEPARATOR,
  NABC_HORIZONTAL_SPACING_ADJUSTMENT,
  NABC_GLYPH_MODIFIER,
  NABC_PITCH,

  NABC_BASIC_GLYPH_GALL,
  NABC_SUBPUNCTIS_AND_PREPUNCTIS_GALL,
  NABC_SIGNIFICANT_LETTER_GALL,

  NABC_BASIC_GLYPH_LAON,
  NABC_SUBPUNCTIS_AND_PREPUNCTIS_LAON,
  NABC_SIGNIFICANT_LETTER_LAON,
  NABC_SIGNIFICANT_LETTER_TIRONIAN_LAON,
  // NABC_ERROR,
};
